
import { ControlFacet } from '../models/controls/ControlFacet';
import { openItem } from '../operations/openItem';
import { IItemCacheThunkAction, IDispatch } from '../store/actions/ItemCacheActions';
import { IFaceted } from '../models/Facet';
import { IItemCacheState } from '../store/reducers/itemCacheReducer';

export const openActionControl = new ControlFacet<{
  itemsScopeItemKey: string;
}, {
    itemKey: string;
    openItem: (payload: typeof openItem.payloadType) => IItemCacheThunkAction<void>;
  }>('openActionControl');

// @ts-ignore
type __unused_declarations = Pick<
  IDispatch<never> |
  IFaceted |
  IItemCacheState,
  never>;
